<ion-header>
  <ion-toolbar>
    <ion-back-button
      color="dark"
      slot="start"
      defaultHref="/home"
      text=""
      icon="chevron-back"
    ></ion-back-button>

    <ion-title *ngIf="didInit && dataServ.menuItem">
      <ion-text color="dark" class="ion-text-center">
        <h1>{{ dataServ.menuItem.name | caption | translate }}</h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="didInit && dataServ.menuItem">
  <ion-grid class="content-grid">
    <!-- OTEL KAPALI UYARISI -->
    <ion-row *ngIf="!dataServ.requestActive">
      <ion-col size="12" class="ion-no-padding">
        <div class="hotel-closed-alert">
          <div
            style="
              padding: 12px;
              background: #ffeded;
              color: #b71c1c;
              text-align: center;
            "
          >
            <ion-icon
              name="alert-circle"
              style="vertical-align: middle; margin-right: 6px"
            ></ion-icon>
            {{ "Hotel Closed Alert" | translate }}
          </div>
        </div>
      </ion-col>
    </ion-row>
    <!-- /OTEL KAPALI UYARISI -->

    <ion-row>
      <ion-col size="12">
        <div class="safe-area"></div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="phoneNo">
      <ion-col size="12">
        <ion-text color="dark">
          <h5>
            {{ "Phone Number" | translate }} <b>{{ phoneNo }}</b>
          </h5>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="ion-no-padding">
        <ion-list>
          <ion-item
            (click)="
              dataServ.requestActive &&
                (!this.dataServ.rData.call_for_requests
                  ? modalServ.request(service)
                  : call())
            "
            *ngFor="
              let service of dataServ.menuItem.menu_item_title_and_descriptions
            "
          >
            <ion-img
              [src]="service.image_url"
              *ngIf="service.image_url"
              slot="start"
            ></ion-img>
            <ion-label
              color="primary"
              [innerHtml]="service.title | caption | translate"
            ></ion-label>
            <img src="assets/svg/card.svg" slot="end" />
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
